import { useQuery } from '@tanstack/react-query';
import supabaseClient from '@/api/supabaseClient.ts';
import type { Tables } from '$/database.types';

export type AdminUser = Pick<
  Tables<'users'>,
  'id' | 'email' | 'role' | 'brand_role' | 'created_at' | 'org_id'
> & {
  organization_name: string | null;
  decision_count: number;
  last_decision_at: string | null;
  onboarding_complete: boolean;
};

async function fetchAdminUsers(): Promise<AdminUser[]> {
  const { data, error } = await supabaseClient.functions.invoke('admin-users', {
    method: 'GET',
  });

  if (error) throw new Error(error.message ?? 'Failed to fetch users');
  return (data?.data ?? []) as AdminUser[];
}

const useAdminUsers = () =>
  useQuery({
    queryKey: ['admin-users'],
    queryFn: fetchAdminUsers,
  });

export default useAdminUsers;
